import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileArrowDown } from "@fortawesome/free-solid-svg-icons";
import AppButton from "../../../Components/Common/Button";
import CurrencyRadioGroup from "../../../Components/Common/CurrencyRadioGroup";
import ExpiryDaysInput from "../../../Components/Common/ExpiryDaysInput";
import FileUpload from "../../../Components/Common/FileUpload";
import { useBulkTransferForm } from "../../../Components/S2STransferForms";
import { CURRENCY_IDS } from "../../../constants/currency";

export default function BulkPaymentForm({ onOpenQrAfterGenerate }) {
  const {
    payload,
    selectedFile,
    setSelectedFile,
    errors,
    downloadTemplate,
    updateCurrency,
    clearFileError,
    setPayload,
    setErrors,
    handleSubmit,
  } = useBulkTransferForm({ onOpenQrAfterGenerate });

  return (
    <form className="make-payment-bulk" onSubmit={handleSubmit} autoComplete="off">
      <div className="make-payment-bulk__section">
        <CurrencyRadioGroup
          label="From Account"
          name="makePaymentBulkCurrency"
          value={String(payload.CurrencyID)}
          onChange={updateCurrency}
          options={[
            { value: String(CURRENCY_IDS.USD), label: "USD" },
            { value: String(CURRENCY_IDS.LBP), label: "LBP" },
          ]}
          error={errors.CurrencyID}
        />
      </div>

      <div className="make-payment-bulk__section">
        <ExpiryDaysInput
          required
          value={payload.DaysToExpire}
          error={errors.DaysToExpire}
          onChange={(nextValue) =>
            setPayload((currentPayload) => ({
              ...currentPayload,
              DaysToExpire: nextValue,
            }))
          }
          onClearError={() =>
            setErrors((currentErrors) => ({
              ...currentErrors,
              DaysToExpire: "",
            }))
          }
        />
      </div>

      <div className="make-payment-bulk__section">
        <span className="make-payment-bulk__label">Sample File</span>

        <button
          type="button"
          className="make-payment-bulk__sample"
          onClick={downloadTemplate}
        >
          <span className="make-payment-bulk__sample-copy">
            <strong>Need the template?</strong>
            <p>Use the latest Suyool bulk transfer sample file before uploading.</p>
          </span>
          <FontAwesomeIcon icon={faFileArrowDown} />
        </button>
      </div>

      <div className="make-payment-bulk__section">
        <FileUpload
          label="Upload Document"
          title="Choose Document"
          accept=".xls,.xlsx"
          maxFileSize={2 * 1024 * 1024}
          compact
          selectedFile={selectedFile?.size > 0 ? selectedFile : null}
          error={errors.formFile}
          onValidationError={clearFileError}
          onFileChange={setSelectedFile}
        />
      </div>

      <AppButton type="submit" className="make-payment-page__continue">
        Continue
      </AppButton>
    </form>
  );
}
